import TopBrands from "@/app/parts/global/TopBrands";
import React from "react";

interface TopBrandsSectionProps { }

export const TopBrandsSection = (_props: TopBrandsSectionProps): React.FunctionComponentElement<TopBrandsSectionProps> =>
    <TopBrands />;
